<template>
  <div>
    <rp-enterkey
      v-model="keyData"
      :errors="errors"
      @submit="onSubmit"
    />
    <rp-overlay :active="activeOverlay">
      <rp-alert
        icon="done"
        :message="successMessage"
        :onClick="successFunction" />
    </rp-overlay>
  </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import Overlay from 'raypro_ui/src/components/ui/Overlay'
import Alert from 'raypro_ui/src/components/ui/Alert'
import page from '@/mixins/page'
import EnterRegistrationKey from 'raypro_ui/src/components/ui/forms/EnterRegistrationKey'
import {assignProductKey} from 'raypro_ui/src/api/product_keys'

export default {
  components: {
    'rp-overlay': Overlay,
    'rp-alert': Alert,
    'rp-enterkey': EnterRegistrationKey
  },

  mixins: [page],

  data() {
    return {
      errors: {},
      activeOverlay: false,
      successMessage: 'Registration successful! Please log back in to activate your subscription.',
      title: 'Enter Registration Key',
      keyData: {key: ''}
    }
  },

  computed: {
    ...mapGetters(['authUser', 'getAuthToken']),

    keyDataPayload() {
      return {data: this.keyData}
    }
  },

  methods: {
    ...mapActions(['logoutUser']),

    successFunction() {
      this.activeOverlay = false
      this.logoutUser(this.getAuthToken)
        .then(() => {
          this.$router.push({name: 'Login'})
        })
        .catch(() => {
        })
    },

    onSubmit() {
      assignProductKey(this.authUser.id, this.keyDataPayload)
        .then(() => {
          this.activeOverlay = true
        })
        .catch(({response}) => {
          this.errors = response
        })
    }
  }
}
</script>

<style lang="sass" scoped>
</style>



// WEBPACK FOOTER //
// src/components/pages/Settings/EnterRegistrationKey.vue